import { render, staticRenderFns } from "./Tienda.vue?vue&type=template&id=6d0be440&scoped=true&"
import script from "./Tienda.vue?vue&type=script&lang=js&"
export * from "./Tienda.vue?vue&type=script&lang=js&"
import style0 from "./Tienda.vue?vue&type=style&index=0&id=6d0be440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0be440",
  null
  
)

export default component.exports